/** Branch trees (GET branches by company, with children): options for pickers (pure). */

/** Every branch as { value, label } with the depth shown by dashes. */
export const branchOptions = (nodes, depth = 0, out = []) => {
  (nodes || []).forEach((b) => {
    out.push({ value: b.id, label: `${"— ".repeat(depth)}${b.branchName}` });
    branchOptions(b.children, depth + 1, out);
  });
  return out;
};

const managerIdOf = (b) => b.branchManagerId || b.branchManager?.id || null;

/**
 * Branches this employee manages and everything under them (what a BRANCH
 * scope role may target). Their own branch only counts if they manage it.
 */
export const managedBranchOptions = (nodes, employeeId) => {
  const out = [];
  const walk = (list, depth, inside) =>
    (list || []).forEach((b) => {
      const mine = inside || (!!employeeId && managerIdOf(b) === employeeId);
      if (mine)
        out.push({
          value: b.id,
          label: `${"— ".repeat(depth)}${b.branchName}`,
        });
      walk(b.children, mine ? depth + 1 : depth, mine);
    });
  walk(nodes, 0, false);
  return out;
};
